import React from "react";
import { useSelector } from "react-redux";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "./Clients.scss";

export const Clients = (props) => {
  const { logos } = props;
  const lang = useSelector((state) => state.locale.lang);
  const responsive = {
    0: {
      items: 1,
      nav: true,
    },
    600: {
      items: 3,
      nav: true,
    },
    1200: {
      items: 5,
      nav: true,
      loop: true,
    },
  };
  return (
    <>
      {Object.values(logos).length && (
        <div className="container">
          <div className=" clients m-auto px-md-5 px-4 py-4">
            <div className="client__title text-center my-2 my-md-4">
              <h2 className="text-uppercase bold_font">
                {lang === "ar" ? "عملائنا" : "Our clients"}

              </h2>
            </div>
            <div className="client__content">
              <OwlCarousel
                responsive={responsive}
                className="p-2 p-md-4 d-flex justify-content-center align-items-center"
                dots={false}
                autoplayTimeout={2000}
                autoplay
                loop
                margin={20}
                nav
                center
              >
                {Object.values(logos).map((logo, index) => (
                  
                  <a href={logo.candidate_portal_url} key={index}>
                    <img src={logo.logo} alt={index} className="logo  m-auto" />
                  </a>
                ))}
              </OwlCarousel>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
